module.exports = __webpack_public_path__ + "img/map_grey.9ea85a12.svg";